import { Request } from "Utils/Request"
import { API_BASE_URL } from 'config.js';

const getRiskQuestions = (params, onSuccess, onFail) => {
    return Request({ url: API_BASE_URL + 'risk_questions?is_new=false', method: 'get', params }, onSuccess, onFail);
}
const getRiskQuestionsJP = (params, onSuccess, onFail) => {
    return Request({ url: API_BASE_URL + 'risk_questions?is_new=false&language=jp', method: 'get', params }, onSuccess, onFail);
}
const getGrades = (params, onSuccess, onFail) => {
    return Request({ url: API_BASE_URL + 'grades', method: 'get', params }, onSuccess, onFail);
}
const getGradesJP = (params, onSuccess, onFail) => {
    return Request({ url: API_BASE_URL + 'grades?language=jp', method: 'get', params }, onSuccess, onFail);
}
export default {
    getRiskQuestions,
    getRiskQuestionsJP,
    getGrades,
    getGradesJP
}